<template>
  <!--If there is data and not mobile render component-->
  <div v-if="Object.keys(detailedRace).length > 0 && !isMobile" class="raceinfo">
    <div class="commentContainer pb-3 pl-3" v-if="detailedRace.comments">
      <!-- Temporary until FC Comments are back for Harness -->
      <template v-if="(detailedRace.meeting.type !== 'HARNESS' && detailedRace.meeting.track.country !== 'JPN')">
        <div class="comment mt-3 mr-4 mb-3">
          <v-chip
            label
            class="primaryTxt"
            color="primaryCol subtitle-2 mb-2"
          >Race Overview &amp; Tips</v-chip>
          <br />
          <span class="text-justify body-2">{{getRaceComment(detailedRace.comments)}}</span>
        </div>
      </template>
      <div class="tips mr-3 mt-3">
        <!--Race tips section-->
        <v-row dense>
          <v-col v-for="d in tips" :key="d" cols="12">
            <!--Render if the tip is not scratched-->
            <v-card elevation="1" v-if="!getTipScratched(d)">
              <div
                class="d-flex flex-no-wrap justify pt-n1"
                style="cursor: pointer"
                @click="scrollToRunner(d)"
              >
                <v-row dense class="pr-1">
                  <v-col cols="2">
                    <v-avatar class="mr-0 mt-1" size="40" tile>
                      <img
                        v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'"
                        :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d+'_64x64.png'"
                        style="height:40px;width:40px"
                      />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d]" />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d]" />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d]" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10">
                    <div>
                      <div
                        class="float-left font-weight-bold mt-3"
                        style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height:22px;width:auto;"
                      >{{d}}. {{getTipName(d)}}</div>
                      <v-btn
                        style="cursor:default"
                        color="grey lighten-2"
                        normal
                        width="60"
                        class="float-right mb-0 ml-1 font-weight-bold subtitle-2 mt-1"
                      >{{getTipPrice(d)}}</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
            <!--Render if the tip is scratched-->
            <v-card elevation="1" v-else-if="getTipScratched(d)">
              <div
                  class="d-flex flex-no-wrap justify pt-n1"
                  style="cursor: pointer"
                  @click="scrollToRunner(d)"
              >
                <v-row dense class="pr-1">
                  <v-col cols="2">
                    <v-avatar class="mr-0 mt-1" size="40" tile>
                      <img
                        v-if="detailedRace.meeting.type === 'THOROUGHBRED' || detailedRace.meeting.type === 'HARNESS'"
                        :src="$silksUrl+'/'+gbsID+'_'+detailedRace.number+'_'+d+'_64x64.png'"
                        style="height:40px;width:40px"
                      />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'GBR' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d]" />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'AUS' || detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'NZL' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d]" />
                      <div v-if="detailedRace.meeting.type === 'GREYHOUND' && detailedRace.meeting.track.country === 'USA' || detailedRace.meeting.track.country === 'MEX' && d" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d]" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10">
                    <div>
                      <div
                          class="float-left font-weight-bold mt-3"
                          style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;height:22px;width:auto;text-decoration: line-through; color: grey"
                      >{{d}}. {{getTipName(d)}}</div>
                      <v-btn
                          style="cursor:default"
                          color="grey lighten-2"
                          normal
                          width="60"
                          disabled
                          class="float-right mb-0 ml-1 font-weight-bold title mt-1"
                      >-</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </div>
    </div>
    <div style="height: 60px" v-else>
    </div>
  </div>
</template>

<script>
import { format } from 'date-fns'
import ordinal from 'ordinal'
import numeral from 'numeral'
// import RunnerFlucs from '@/components/RunnerFlucs'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'RaceName',
  components: {
    // RunnerFlucs
  },
  data () {
    return {
      numeral,
      format,
      ordinal,
      tips: [],
      raceTypeImg: {
        HARNESS: '/img/race_types/DO_RaceType_Harness-BLACK.svg',
        GREYHOUND: '/img/race_types/DO_RaceType_Greyhounds-BLACK.svg',
        THOROUGHBRED: '/img/race_types/DO_RaceType_Gallops-BLACK.svg'
      }
    }
  },
  created () {
    this.checkString()
  },
  computed: {
    ...mapState(['detailedRace', 'gbsID', 'bestOddsArray']),
    ...mapGetters(['isMobile'])
  },
  methods: {
    getRaceComment (comments) {
      const filteredComments = comments.filter(b => b.source !== 'RAS')
      return filteredComments[0].comment
    },
    scrollToRunner (tabNo) {
      window.location.href = `#${tabNo}`
    },
    checkString: function () {
      if (this.raceComment) {
        const regex = /\(([^()]*)\)/g
        const numbers = this.raceComment.match(regex).map(x => x.replace(/[()]/g, ''))
        if (numbers.length > 4) {
          numbers.length = 4
        }
        this.tips = numbers
      }
    },
    getTipName (tabNo) {
      let runnerName = 0
      this.raceFlucs.competitors.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          runnerName = b.name
        }
      })
      return `${runnerName}`
    },
    getTipScratched (tabNo) {
      let isScratched
      this.raceFlucs.competitors.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          if (b.scratched) {
            isScratched = true
          } else {
            isScratched = false
          }
        }
      })
      return isScratched
    },
    getTipPrice (tabNo) {
      let fixedPrice = 0
      if (this.bestOddsArray.length >= 1) {
        this.bestOddsArray.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            fixedPrice = b.price
          }
        })
      } else {
        this.raceFlucs.competitors.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            const flucs = b.flucs.map(a => a.price)
            fixedPrice = flucs[flucs.length - 1] || 0
          }
        })
      }
      return `$${fixedPrice.toFixed(2)}`
    },
    getTipPastFin (tabNo) {
      let runner = {}
      this.raceFlucs.competitors.forEach(b => {
        // eslint-disable-next-line eqeqeq
        if (tabNo == b.tabNo) {
          runner = b.runner.competitorsConnection.competitors
        }
      })
      const finalPos = runner.map(b => {
        if (b.finalPosition > 9) {
          return 0
        }
        return b.finalPosition
      })
      // console.log(finalPos)
      const finalPosStr = finalPos.toString()
      const final = parseFloat(finalPosStr.replace(/,/g, ''))
      return final
    }
  },
  props: {
    raceFlucs: Object,
    raceComment: String
  }
}
</script>

<style scoped>
::v-deep .v-toolbar__content {
  padding: 0px 0px !important;
  height: 45px !important;
}
::v-deep .v-toolbar__extension {
  padding: 0px 0px !important;
}
.commentContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 70% auto;
  grid-template-areas: "comment tips";
  background: #f3f3f3;
}
.color-Firm {
  color: rgb(0, 204, 255);
}
.color-Firm1 {
  color: rgb(0, 204, 255);
}
.color-Firm2 {
  color: rgb(0, 204, 255);
}
.color-Good {
  color: rgb(0, 219, 0);
}
.color-Good3 {
  color: rgb(0, 219, 0);
}
.color-Good4 {
  color: rgb(0, 219, 0);
}
.color-Soft {
  color: rgb(224, 210, 56);
}
.color-Soft5 {
  color: rgb(224, 210, 56);
}
.color-Soft6 {
  color: rgb(224, 210, 56);
}
.color-Soft7 {
  color: rgb(224, 210, 56);
}
.color-Heavy {
  color: orange;
}
.color-Heavy8 {
  color: orange;
}
.color-Heavy9 {
  color: orange;
}
.color-Heavy10 {
  color: orange;
}
.color-Synthetic {
  color: purple;
}
.raceinfo {
  line-height: 25px;
  width: 100%;
  text-align: justify;
  font-size: 14px;
  max-width:1024px;
  min-width:1024px;
  background-color: white;
  box-shadow: 3px 5px 5px lightgrey;
}
.raceinfoMobile {
  width: 100%;
  text-align: justify;
  background-color: white;
  box-shadow: 3px 5px 5px lightgrey;
}
.raceTips {
  grid-area: tips;
}
@media screen and (max-width: 480px) {
  .raceTips {
    display: none;
  }
}
/* UK Greys */
.greyhoundSpriteUk-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUk-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUk-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUk-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUk-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUk-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUk-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUk-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -196px;
}
/* AUS Greys */
.greyhoundSpriteAUS-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteAUS-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteAUS-3 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteAUS-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteAUS-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteAUS-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteAUS-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteAUS-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteAUS-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteAUS-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -252px;
}
/* US Greys */
.greyhoundSpriteUs-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUs-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUs-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUs-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUs-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUs-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUs-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUs-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteUs-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteUs-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -252px;
}
</style>
